import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=2e0e4484&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=2e0e4484&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e4484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0e4484')) {
      api.createRecord('2e0e4484', component.options)
    } else {
      api.reload('2e0e4484', component.options)
    }
    module.hot.accept("./ImageUpload.vue?vue&type=template&id=2e0e4484&scoped=true", function () {
      api.rerender('2e0e4484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/ImageUpload.vue"
export default component.exports